import request from 'lib/request';
import { useUserInfo } from 'lib/user';
import { useCallback, useEffect } from 'react';
import {
  setMintWalletListRaffle,
  setMintWalletListProfile,
} from 'store/features/userSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export interface Response {
  code: number;
  data: List;
  msg: string;
}

export interface List {
  list: MintWalletList[];
}

export interface MintWalletList {
  address: string;
  is_default: number;
  is_main?: number;
  name?: string;
}

export async function getAddressList(chain: string) {
  const res = await request<Response>('/user_profile/address_list', {
    params: {
      chain,
    },
  });
  return res;
}

export function useMintWalletRaffle() {
  const dispatch = useAppDispatch();
  const { mintWallet } = useAppSelector((state) => state.raffleDetails);
  const { mintWalletListRaffle } = useAppSelector((state) => state.user);
  const { isLogin } = useUserInfo();

  const getMintWalletRaffle = useCallback(
    async (chain: string) => {
      if (!isLogin) {
        return;
      }
      const res = await getAddressList(chain);
      if (res?.code === 0) {
        dispatch(setMintWalletListRaffle(res?.data?.list));
      } else {
        dispatch(setMintWalletListRaffle([]));
      }
    },
    [dispatch, isLogin]
  );

  return {
    getMintWalletRaffle,
  };
}

export function useMintWalletProfile() {
  const dispatch = useAppDispatch();
  const { isLogin } = useUserInfo();

  const getMintWalletProfile = useCallback(
    async (chain: string) => {
      if (!isLogin) {
        return;
      }
      const res = await getAddressList(chain);
      if (res?.code === 0) {
        dispatch(setMintWalletListProfile(res?.data?.list));
      } else {
        dispatch(setMintWalletListProfile([]));
      }
    },
    [dispatch, isLogin]
  );

  return {
    getMintWalletProfile,
  };
}
